import { pattern } from '../../validation/pattern.js';
import { required } from '../../validation/required.js';
import { validator } from '../../validation/validator.js';
const ERROR_MESSAGE = 'Некорректно заполненное поле';
export const defaultValidator = required(ERROR_MESSAGE);
export const defaultSelectValidator = validator((_) => _?.key && _?.key !== '')(ERROR_MESSAGE);
export const nameValidator = validator((_) => typeof _ === 'string' && _.length > 1)(ERROR_MESSAGE);
export const innValidator = validator((_) => typeof _ === 'string' && (_.length === 10 || _.length === 12))(ERROR_MESSAGE);
export const phoneValidator = pattern(/^(\+7)?[\s-]?\(?[0-9]{3}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/)(ERROR_MESSAGE);
export const agreementValidator = validator((_) => typeof _ === 'boolean' && _)('Согласие обязательно');
//# sourceMappingURL=validators.js.map